import styled from 'styled-components';
import { StyledLoader } from '../../styled';

export const StyledNewLoader = styled(StyledLoader)`
  position: absolute;
`;

export const StyledFixturesWrapper = styled.div`
  width: 100%;
  min-width: 0;
`;
